function setDynamicHeight() {
  const photoMedias = document.querySelectorAll(`.section-adapt .adapt`);

  photoMedias.forEach((photoMedia) => {
    let wrapper = photoMedia.closest('.adapt-wrapper');
    let aspectRatio = Number(wrapper.dataset.aspect);
    let wrapperWidth = wrapper.offsetWidth;
    let wrapperHeight = wrapperWidth / aspectRatio;
    wrapper.style.height = wrapperHeight + 'px';
  });
}

function scrollLoop() {
  let sections = document.querySelectorAll('.parallax__section');

  sections.forEach((section) => {
    let rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom >= 0) {
      let yScrollPosition = rect.top * 0.2 - 200;
      let mediaElements = section.querySelectorAll('.photo__media');
      let widget = section.querySelector('.product-background__widget');

      mediaElements.forEach((image) => {
        setTranslate(0, yScrollPosition, image);

        if (widget) {
          if (window.innerWidth < 1200) {
            setTranslate(0, -yScrollPosition - 80, widget);
          } else if (window.innerWidth < 1500) {
            setTranslate(0, -yScrollPosition - 100, widget);
          } else {
            setTranslate(0, -yScrollPosition - 50, widget);
          }
        }
      });
    }
  });

  requestAnimationFrame(scrollLoop);
}

function setTranslate(xPos, yPos, el) {
  if (el.classList.contains('product-background__widget')) {
    if (el.classList.contains('right')) {
      el.style.transform = `translate(50%,-50%) translate(${xPos}px, ${yPos}px)`;
    } else {
      el.style.transform = `translate(-50%,-50%) translate(${xPos}px, ${yPos}px)`;
    }
  } else {
    el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`;
  }
}

window.addEventListener('DOMContentLoaded', () => {
  setDynamicHeight();
  scrollLoop();
});

window.addEventListener('resize', () => {
  setDynamicHeight();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    setDynamicHeight();
  });
  document.addEventListener('shopify:section:reorder', () => {
    setDynamicHeight();
  });
}
